import GastroEnteroscopiaList from "./pages/GastroEnteroscopiaList.vue"
import GastroEnteroscopiaView from "./pages/GastroEnteroscopiaView.vue"
import GastroEnteroscopiaEdit from "./pages/GastroEnteroscopiaEdit.vue"

export default{
    GastroEnteroscopiaList,
    GastroEnteroscopiaView,
    GastroEnteroscopiaEdit,
}